const config = {
	minX: 0,
	maxX: 90,
	minY: 0,
	maxY: 190,
	level1: {
		speed: 1500,
		generation: 16000
	},
	level2: {
		speed: 1200,
		generation: 15000
	},
	level3: {
		speed: 900,
		generation: 13000
	},
	level4: {
		speed: 700,
		generation: 12000
	},
	level5: {
		speed: 600,
		generation: 11000
	},
	level6: {
		speed: 500,
		generation: 9000
	},
	level7: {
		speed: 450,
		generation: 8000
	},
	level8: {
		speed: 400,
		generation: 6000
	},
	level9: {
		speed: 300,
		generation: 4000
	},
	level10: {
		speed: 200,
		generation: 3000
	}
}

export default config;